import React, { useState, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Container, Row, Col, Spinner, Alert, Badge, Card, Button, Form } from 'react-bootstrap';
// Update the import to use axios and config directly
import axios from 'axios';
import { config, eventService } from '../services/api';
import EventsGrid from './EventsGrid';
import './EventList.css';




// Keep the imports and WILAYAS array as is
const WILAYAS = [
  { code: '01', name: 'Adrar' },
  { code: '02', name: 'Chlef' },
  { code: '03', name: 'Laghouat' },
  { code: '04', name: 'Oum El Bouaghi' },
  { code: '05', name: 'Batna' },
  { code: '06', name: 'Béjaïa' },
  { code: '07', name: 'Biskra' },
  { code: '08', name: 'Béchar' },
  { code: '09', name: 'Blida' },
  { code: '10', name: 'Bouira' },
  { code: '11', name: 'Tamanrasset' },
  { code: '12', name: 'Tébessa' },
  { code: '13', name: 'Tlemcen' },
  { code: '14', name: 'Tiaret' },
  { code: '15', name: 'Tizi Ouzou' },
  { code: '16', name: 'Alger' },
  { code: '17', name: 'Djelfa' },
  { code: '18', name: 'Jijel' },
  { code: '19', name: 'Sétif' },
  { code: '20', name: 'Saïda' },
  { code: '21', name: 'Skikda' },
  { code: '22', name: 'Sidi Bel Abbès' },
  { code: '23', name: 'Annaba' },
  { code: '24', name: 'Guelma' },
  { code: '25', name: 'Constantine' },
  { code: '26', name: 'Médéa' },
  { code: '27', name: 'Mostaganem' },
  { code: '28', name: 'M\'Sila' },
  { code: '29', name: 'Mascara' },
  { code: '30', name: 'Ouargla' },
  { code: '31', name: 'Oran' },
  { code: '32', name: 'El Bayadh' },
  { code: '33', name: 'Illizi' },
  { code: '34', name: 'Bordj Bou Arréridj' },
  { code: '35', name: 'Boumerdès' },
  { code: '36', name: 'El Tarf' },
  { code: '37', name: 'Tindouf' },
  { code: '38', name: 'Tissemsilt' },
  { code: '39', name: 'El Oued' },
  { code: '40', name: 'Khenchela' },
  { code: '41', name: 'Souk Ahras' },
  { code: '42', name: 'Tipaza' },
  { code: '43', name: 'Mila' },
  { code: '44', name: 'Aïn Defla' },
  { code: '45', name: 'Naâma' },
  { code: '46', name: 'Aïn Témouchent' },
  { code: '47', name: 'Ghardaïa' },
  { code: '48', name: 'Relizane' },
  { code: '49', name: 'El M\'Ghair' },
  { code: '50', name: 'El Meniaa' },
  { code: '51', name: 'Ouled Djellal' },
  { code: '52', name: 'Bordj Baji Mokhtar' },
  { code: '53', name: 'Béni Abbès' },
  { code: '54', name: 'Timimoun' },
  { code: '55', name: 'Touggourt' },
  { code: '56', name: 'Djanet' },
  { code: '57', name: 'In Salah' },
  { code: '58', name: 'In Guezzam' },
];

// Format price helper function
const formatPrice = (price) => {
  if (!price || price===0) return 'Gratuit';
  // Remove decimal places and add thousands separator
  return parseInt(price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' DZD';
};

function EventList() {
  const [events, setEvents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [listLoading, setListLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [refreshing, setRefreshing] = useState(false);
  // Ajout des états pour la pagination
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const eventsPerPage = 6; // Nombre d'événements à charger par page
  
  const [filters, setFilters] = useState({
    category: searchParams.get('category') || '',
    partner: searchParams.get('partner') || '',
    wilaya: searchParams.get('wilaya') || '',
    upcoming: searchParams.get('upcoming') !== 'false',
    search: searchParams.get('search') || ''
  });

  // Load categories and partners on component mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        // Use axios directly instead of eventService.getEventCategories
        const response = await axios.get(`${config.API_URL}/api/categories/`);
        setCategories(response.data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    const fetchPartners = async () => {
      try {
        // Use axios directly instead of partnerService.getPartners
        const response = await axios.get(`${config.API_URL}/api/users/partners/`);
        setPartners(response.data);
      } catch (error) {
        console.error('Error fetching partners:', error);
      }
    };

    fetchCategories();
    fetchPartners();
  }, []);

  // Function to fetch events based on current filters
  const fetchEvents = useCallback(async (isInitialLoad = false, isLoadMore = false) => {
    if (isInitialLoad) {
      setLoading(true);
    } else {
      setListLoading(true);
    }
    setPage(1); // Always reset page since we're removing load more
    setError(null);
    
    try {
      // Build query parameters
      const params = new URLSearchParams();
      if (filters.category) params.append('category', filters.category);
      if (filters.partner) params.append('partner', filters.partner);
      if (filters.wilaya) params.append('wilaya', filters.wilaya);
      if (filters.upcoming) params.append('upcoming', 'true');
      if (filters.search) params.append('search', filters.search);
      
      // Add pagination parameters - load all events at once
      params.append('page_size', 1); // Increased page size to load more events at once
      
      const response = await axios.get(`${config.API_URL}/api/events/`, { params });
      
      // Set hasMore to false since we're not implementing pagination
      setHasMore(false);
      console.log("EVENTS ",response.data);
      // Update events list
      setEvents(response.data || []);
      
      // Update URL with current filters
      const urlParams = new URLSearchParams();
      if (filters.category) urlParams.append('category', filters.category);
      if (filters.partner) urlParams.append('partner', filters.partner);
      if (filters.wilaya) urlParams.append('wilaya', filters.wilaya);
      if (filters.upcoming) urlParams.append('upcoming', 'true');
      if (filters.search) urlParams.append('search', filters.search);
      setSearchParams(urlParams);
      
    } catch (error) {
      console.error('Error fetching events:', error);
      setError('Impossible de charger les événements. Veuillez réessayer plus tard.');
    } finally {
      if (isInitialLoad) {
        setLoading(false);
      } else {
        setListLoading(false);
      }
      setRefreshing(false);
    }
  }, [filters, setSearchParams]);

  // Remove the loadMoreEvents function since we're not using it anymore

  // Keep the effect to load events when component mounts
  useEffect(() => {
    // Initial load of events
    fetchEvents(true);
  }, [fetchEvents]);

  // Remove the scroll event listener since we're not loading more events

  // Function to refresh only the events list
  const refreshEventsList = async () => {
    setRefreshing(true);
    fetchEvents(false);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleUpcomingToggle = (e) => {
    setFilters(prev => ({
      ...prev,
      upcoming: e.target.checked
    }));
  };

  const clearFilters = () => {
    setFilters({
      category: '',
      partner: '',
      wilaya: '',
      upcoming: true,
      search: ''
    });
    // Clear URL parameters
    setSearchParams({});
  };

  const applyFilters = () => {
    fetchEvents(false, false);
  };



  const handleLoadMore = () => {
    if (!refreshing && hasMore) {
      fetchEvents(false, true);
    }
  };

  return (
    <div className="event-list-page py-5 mt-5">
      <Container>
        <h1 className="mb-4 text-center">Nos Événements</h1>
        <p className="text-center mb-5">Découvrez nos événements à venir et réservez votre place dès maintenant.</p>
        
        {/* Filters */}
        <div className="filters-section mb-4 p-3 bg-light rounded">
          <Row>
            <Col md={3} lg={2}>
              <Form.Group className="mb-3">
                <Form.Label>Catégorie</Form.Label>
                <Form.Select 
                  name="category"
                  value={filters.category}
                  onChange={handleFilterChange}
                >
                  <option value="">Toutes les catégories</option>
                  {categories.map(category => (
                    <option key={category.id} value={category.id}>
                      {category.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3} lg={2}>
              <Form.Group className="mb-3">
                <Form.Label>Partenaire</Form.Label>
                <Form.Select 
                  name="partner"
                  value={filters.partner}
                  onChange={handleFilterChange}
                >
                  <option value="">Tous les partenaires</option>
                  {partners.map(partner => (
                    <option key={partner.id} value={partner.id}>
                      {partner.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3} lg={2}>
              <Form.Group className="mb-3">
                <Form.Label>Wilaya</Form.Label>
                <Form.Select 
                  name="wilaya"
                  value={filters.wilaya}
                  onChange={handleFilterChange}
                >
                  <option value="">Toutes les wilayas</option>
                  {WILAYAS.map(wilaya => (
                    <option key={wilaya.code} value={wilaya.code}>
                      {wilaya.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={12} lg={3}>
              <Form.Group className="mb-3 mt-md-4">
                <Form.Check
                  type="checkbox"
                  id="upcoming-events"
                  label="Événements à venir uniquement"
                  checked={filters.upcoming}
                  onChange={handleUpcomingToggle}
                />
              </Form.Group>
              <div className="d-flex gap-2">
                <Button 
                  variant="outline-secondary" 
                  onClick={clearFilters}
                  disabled={refreshing}
                >
                  <i className="fas fa-times me-1"></i> Effacer
                </Button>
                <Button 
                  variant="primary" 
                  onClick={applyFilters}
                  disabled={refreshing}
                >
                  <i className="fas fa-filter me-1"></i> Appliquer
                </Button>
                <Button 
                  variant="outline-primary" 
                  onClick={refreshEventsList}
                  disabled={refreshing || listLoading}
                >
                  <i className={`fas fa-sync-alt me-1 ${refreshing ? 'fa-spin' : ''}`}></i> 
                  Actualiser
                </Button>
              </div>
            </Col>
          </Row>
        </div>
        
        {/* Events list section with loading indicator */}
        <div className="events-list-container position-relative" style={{ minHeight: '400px' }}>
          {(refreshing || listLoading) && (
            <div className="refresh-overlay">
              <Spinner animation="border" variant="primary" />
            </div>
          )}
          
          <EventsGrid 
            events={events}
            loading={loading}
            error={error}
            hasMore={false} // Always false since we're not implementing pagination
            refreshing={refreshing}
            onLoadMore={null} // Remove the load more functionality
          />
        </div>
      </Container>
    </div>
  );
}

export default EventList;